import React from "react";
import PropTypes from "prop-types";
import { AlertCircleFilled, Clock } from '@sainsburys-tech/icons'
import TickIcon from "../TickIcon";
import * as overrideStages from "../../model/lighting-overrides/overrideStageKeys";

const OverrideStageIcon = props => {
  switch (props.stage) {
    case overrideStages.COMPLETED:
      return <TickIcon />;
    case overrideStages.FAILED:
    case overrideStages.DISCARD_FAILED:
      return <AlertCircleFilled className="fable:text-red-600" size="large" />;
    case overrideStages.POSTING:
    case overrideStages.DISCARDING:
      return <Clock className="fable:text-gray-600" size="large" />;
    default:
      return <span className="fable:ml-12" />;
  }
};

OverrideStageIcon.propTypes = {
  stage: PropTypes.string
};

export default OverrideStageIcon;
